'use client'
import { useLazyUserProfileDetailsQuery } from '@/src/api/rtkQuery/userApi'
import { refreshAuthUser } from '@/src/redux/slices/authSlice'
import {
    invokeCustomEvent,
    loginPush,
    responseMapper,
    sendProfileData,
    updateProfileData
} from '@/src/utils/analytics/clevertap'
import { isServer } from '@/src/utils/browser'
import { getMobileDeviceType } from '@/src/utils/deviceType'
import { isUserSignedIn } from '@/src/utils/generalUtils/checkUserLogin'
import { logError } from '@/src/utils/logError'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

export default function GlobalClientEffect() {
    const [triggerUserProfileDetails] = useLazyUserProfileDetailsQuery()
    const dispatch = useDispatch()

    const getUserDetails = async (type: string) => {
        try {
            const response = await triggerUserProfileDetails()
            const { status, data } = response || {}
            if (status === 'fulfilled') {
                let finalPayload = responseMapper(data)
                if (type == 'login') {
                    sendProfileData(finalPayload)
                } else {
                    updateProfileData(finalPayload)
                }
            }
        } catch (e) {
            logError('getUserDetails', e)
        }
    }

    useEffect(() => {
        if (!isServer()) {
            dispatch(refreshAuthUser())

            document.addEventListener('CLEVERTAP_PROFILE', function ({ detail }: any) {
                const deviceType = getMobileDeviceType()
                if (deviceType !== 'AndroidApp' && deviceType !== 'iPhoneApp'){
                    const { type } = detail || {}
                    getUserDetails(type)
                }
            })

            if (isUserSignedIn() && !loginPush) {
                invokeCustomEvent('CLEVERTAP_PROFILE', { type: 'login' })
            }
        }
    }, [dispatch])

    return null
}
